import type { ReactNode } from "react";
import { Button } from "./Button";

interface ModalProps {
  title: string;
  children: ReactNode;
  onClose: () => void;
  footer?: ReactNode;
}

export function Modal({ title, children, onClose, footer }: ModalProps) {
  return (
    <div style={styles.overlay} onClick={onClose} role="presentation">
      <div
        style={styles.card}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <h3 style={styles.title}>{title}</h3>
        <div style={styles.body}>{children}</div>
        <div style={styles.footer}>
          {footer ?? <Button onClick={onClose}>Close</Button>}
        </div>
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.35)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
    padding: 24,
  },
  card: {
    background: "var(--comp-paper)",
    border: "1px solid var(--comp-rule)",
    borderRadius: "var(--radius-lg)",
    width: "100%",
    maxWidth: 480,
    padding: "var(--space-4)",
  },
  title: {
    fontSize: 13,
    fontWeight: 600,
    margin: "0 0 var(--space-4)",
    color: "var(--fg-1)",
  },
  body: {
    fontSize: 13,
    color: "var(--fg-2)",
    lineHeight: 1.6,
  },
  footer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 8,
    marginTop: "var(--space-4)",
  },
};
